import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { urlReplacer } from "../../../utils";
import { stringify } from "query-string";
import { ApiRoutes } from "../../../constants/apiRoutes";

export default function () {
  const { request } = useApi();
  return {
    fetchAll: useCallback(
      async ({ schoolId }) => {
        return request({
          method: "GET",
          url: `${ApiRoutes.BRANCHES}?schoolId=${schoolId}`,
        });
      },
      [request],
    ),

    filterBranches: useCallback(
      async (data?) => {
        return request({
          method: "GET",
          url:
            ApiRoutes.FILTER_BRANCHES +
            (data
              ? `?${stringify({
                  includeFavorites: true,
                  majors: data.major && data.major.id,
                  degrees: data.degree && data.degree.id,
                  schools: data.school && data.school.id,
                  tuitionMin: data.tuition && data.tuition[0],
                  tuitionMax: data.tuition && data.tuition[1],
                })}`
              : `?${stringify({
                  includeFavorites: true,
                })}`),
        });
      },
      [request],
    ),

    fetchOne: useCallback(
      async (id) => {
        return request({
          method: "GET",
          url: `${urlReplacer(ApiRoutes.GET_BRANCH, {
            id,
          })}`,
        });
      },
      [request],
    ),

    fetchCreate: useCallback(
      async (data) => {
        return request({
          data: data,
          method: "POST",
          url: ApiRoutes.CREATE_BRANCH,
        });
      },
      [request],
    ),

    fetchUpdate: useCallback(
      async (id, data) => {
        return request({
          data: data,
          method: "PUT",
          url: urlReplacer(ApiRoutes.UPDATE_BRANCH, { id }),
        });
      },
      [request],
    ),

    fetchDelete: useCallback(
      async (id) => {
        return request({
          method: "DELETE",
          url: `${urlReplacer(ApiRoutes.DELETE_BRANCH, { id })}`,
        });
      },
      [request],
    ),
  };
}
